// @flow

import { useSelector } from "react-redux";
import React from "react";

import { MenuItem, Value } from "./styles";
import defaultStatus, * as status from "src/constants/status";
import { getChatroomStatus } from "src/reducers";
import type { RoomId } from "src/types";
type Props = {
  handleStatus: Function,
  roomId: RoomId,
};

const Conversation = ({ handleStatus, roomId }: Props) => {
  const pending = defaultStatus[status.PENDING];
  const completed = defaultStatus[status.COMPLETED];
  const canceled = defaultStatus[status.CANCELED];
  const value = useSelector(({ app }) => getChatroomStatus(app, roomId));

  return (
    <>
      <MenuItem
        tabIndex="0"
        role="button"
        onClick={() => handleStatus(status.PENDING)}
        onKeyPress={() => handleStatus(status.PENDING)}
      >
        <Value color={pending.color} textColor={pending.textColor}>
          {pending.text}
        </Value>
        <span
          dangerouslySetInnerHTML={{
            __html: `${value === status.PENDING ? "&#10004;" : ""}`,
          }}
        />
      </MenuItem>
      <MenuItem
        tabIndex="0"
        role="button"
        onClick={() => handleStatus(status.COMPLETED)}
        onKeyPress={() => handleStatus(status.COMPLETED)}
      >
        <Value color={completed.color} textColor={completed.textColor}>
          {completed.text}
        </Value>
        <span
          dangerouslySetInnerHTML={{
            __html: `${value === status.COMPLETED ? "&#10004;" : ""}`,
          }}
        />
      </MenuItem>
      <MenuItem
        tabIndex="0"
        role="button"
        onClick={() => handleStatus(status.CANCELED)}
        onKeyPress={() => handleStatus(status.CANCELED)}
      >
        <Value color={canceled.color} textColor={canceled.textColor}>
          {canceled.text}
        </Value>
        <span
          dangerouslySetInnerHTML={{
            __html: `${value === status.CANCELED ? "&#10004;" : ""}`,
          }}
        />
      </MenuItem>
    </>
  );
};

export default Conversation;
